import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function TapCard({ simulatedCardAddress }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Read walletAddress from navigation state
  const { walletAddress } = location.state || {};

  const handleCardTap = () => {
    if (!walletAddress) {
      alert("Wallet address missing!");
      return;
    }

    // Pass both walletAddress and cardAddress to RegisterCard
    navigate("/register-card", { 
      state: { walletAddress, cardAddress: simulatedCardAddress } 
    });
  };

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-900 to-gray-800 text-white p-6">
      <h1 className="text-2xl font-semibold mb-6">Tap Your Card</h1>
      <p className="text-gray-400 text-center max-w-xs mb-10">
        Place your card near your device to begin registration.
      </p>

      <button
        onClick={handleCardTap}
        className="bg-blue-600 px-6 py-3 rounded-xl text-lg font-bold hover:bg-blue-700 shadow-lg transition"
      >
        Simulate Tap
      </button>
    </div>
  );
}
